<section class="globe-section">
  <div class="canvas-container">
    <canvas #globeCanvas></canvas>
  </div>

  <svg 
    class="tether-overlay" 
    [attr.viewBox]="'0 0 ' + canvasWidth + ' ' + canvasHeight"
    preserveAspectRatio="none"
  >
  @for (prop of visibleProperties(); track prop.id) {
    @if (prop.isDocked) {
      <!-- Glow layer (behind) -->
      <line 
        class="tether-glow"
        [attr.x1]="prop.markerX" [attr.y1]="prop.markerY"
        [attr.x2]="prop.screenX" [attr.y2]="prop.screenY! - cardVisualHeight"
      />
      <!-- Main dashed line -->
      <line 
        [attr.x1]="prop.markerX" [attr.y1]="prop.markerY"
        [attr.x2]="prop.screenX" [attr.y2]="prop.screenY! - cardVisualHeight"
      />
    }
  }
  </svg>

  <div class="markers-overlay">
    @for (prop of visibleProperties(); track prop.id) {
      <div 
        class="marker-container"
        [id]="'marker-wrapper-' + prop.id"
        [style.left.px]="prop.screenX"
        [style.top.px]="prop.screenY"
      >
        <div class="property-card featured" [class.docked]="prop.isDocked">
          <div class="card-inner">
            <div class="ribbon">
              <div class="ribbon-inner">
                <i class="fa-solid fa-star"></i>
                <span>FEATURED</span>
              </div>
            </div>
            <img [src]="prop.imageUrl" [alt]="prop.title" class="prop-img">
            <div class="card-content">
              <h4>{{ prop.title }}</h4>
              <a [href]="prop.link" class="book-btn">View Property</a>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
</section>